<div class="d-flex flex-column h-100" (clickOutside)="closePanel()" appClickOutside>
  <div class="activity-header">
    <span class="activity-title">
      <i class="fa-regular fa-wave-pulse" aria-hidden="true"></i>
      Notifications
    </span>
    <button class="close-btn transparent" (click)="closePanel()">
      <i class="fa-regular fa-xmark" aria-hidden="true"></i>
    </button>
  </div>

  @let notificationsType = notificationsPanelService.openNotifications();

  <div class="activity-tabs">
    <button class="activity-tab"
            (click)="changeTab(NotificationType.holidays)"
            [ngClass]="{'active': notificationsType === NotificationType.holidays}">{{ NotificationType.holidays }}
    </button>

    <button class="activity-tab"
            (click)="changeTab(NotificationType.systems)"
            [ngClass]="{'active': notificationsType === NotificationType.systems}">{{ NotificationType.systems }}
    </button>
  </div>

  <div class="activity-content">
    @if (notificationsType === NotificationType.holidays) {
      @if (holidayNotifications()?.length == 0) {
        <div class="no-notifications">
          <i class="fa-solid fa-bell" aria-hidden="true"></i>
          <p>No Notifications</p>
        </div>
      }

      @for (notification of holidayNotifications(); track notification.Id) {
        <app-holiday-notification [notification]="notification"/>
      }
    } @else if (notificationsType === NotificationType.systems) {
      @if (notifications()?.length == 0) {
        <div class="no-notifications">
          <i class="fa-solid fa-bell" aria-hidden="true"></i>
          <p>No Notifications</p>
        </div>
      }

      @for (notification of notifications(); track notification.EntityId) {
        <app-system-notification
          [notification]="notification"
          (delete)="deleteSystemNotification(notification)"
          (update)="updateSystemNotification($event)"/>
      }
    }
  </div>
</div>
